import { operatorApiFetch } from './apiService';

export const pickingListPresetService = {
  getRecords: async (params) => {
    const response = await operatorApiFetch('picking_list_presets', {
      method: 'GET',
      params
    });
    return response.json();
  },

  get: async (id) => {
    const response = await operatorApiFetch(`picking_list_presets/${id}`, {
      method: 'GET'
    });
    return response.json();
  },

  create: async (data) => {
    const response = await operatorApiFetch('picking_list_presets', {
      method: 'POST',
      body: data
    });
    return response.json();
  },

  update: async (id, data) => {
    const response = await operatorApiFetch(`picking_list_presets/${id}`, {
      method: 'PUT',
      body: data
    });
    return response.json();
  },

  delete: async (id) => {
    const response = await operatorApiFetch(`picking_list_presets/${id}`, {
      method: 'DELETE'
    });
    return response.json();
  },

  simulate: async (id) => {
    const response = await operatorApiFetch(`picking_list_presets/${id}/simulate`, {
      method: 'POST'
    });
    return response.json();
  },
};
